export default () => ({
    setVideoSource(desktopURL, mobileURL) {
        const video = this.$refs.video;
        const screenWidth = window.innerWidth
        const isMobile = screenWidth<=1023

        let deviceSource = isMobile ? mobileURL : desktopURL;
        video.querySelector("source").setAttribute('data-src', deviceSource);
        video.querySelector("source").src = isMobile ? mobileURL : desktopURL;
    }
});
